<template>
  <div class="wrapper" ref="scrollView" @scroll="handleScroll">
    <van-search
      v-model="value"
      shape="round"
      background="#F8F8F8"
      placeholder="搜索名称"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon">
      </template>
    </van-search>
    <div class="type_cl">
      <span class="title">类型选择</span>
      <span @click="handleTab(1)" :class="current === 1 ? 'option gg' : 'option'">药品</span>
      <span @click="handleTab(2)" :class="current === 2 ? 'option gg' : 'option'">项目</span>
      <span @click="handleTab(3)" :class="current === 3 ? 'option gg' : 'option'">物资资料</span>
    </div>
    <ul class="list_cl">
      <li>
        <!-- <span>类别</span> -->
        <span>名称</span>
        <span>门诊单价</span>
        <span>住院单价</span>
        <span>单位</span>
        <span>规格</span>
      </li>
      <li v-for="item in list" :key="item.itemCode">
        <!-- <span>{{ item.typeName }}</span> -->
        <span>{{ item.itemName }}</span>
        <span>{{ parseFloat(item.mzPrice) }} 元</span>
        <span>{{ parseFloat(item.zyPrice) }} 元</span>
        <span>{{ item.unit }}</span>
        <span>{{ item.spec && item.spec.trim().length ? item.spec : '无' }}</span>
      </li>
    </ul>
    <div v-if="loading" class="load_cal">
      <!-- <van-loading size="24px">加载中...</van-loading> -->
      没有更多了
    </div>
  </div>
</template>

<script>
import { getItemPrices } from "@/request/api.js";
import { throttle } from "@/tool/shake.js";

const USER_ID = "7148";
export default {
  data() {
    return {
      current: 1,
      pagemun: 1,
      value: "",
      list: [],
      loading: false, // true=没有更多了
      isFetching: false
    }
  },
  created() {
    this.getList();
    this.handleScroll = throttle(this.handleScroll1, 200);
  },
  methods: {
    handleScroll1(e) {
      if (this.loading || this.isFetching) return;
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollTop + clientHeight > scrollHeight - 50) {
        this.pagemun++;
        this.getList();
      }
    },
    async getList(){
      if (this.loading || this.isFetching) return;
      this.isFetching = true;
      const map = {
        lsType: this.current,
        nameCode: this.value,
        userId: USER_ID,
        pagemun: this.pagemun,
        pagesize: 20,
      }
      try {
        const res = await getItemPrices(map);
        const ok = res.data && res.data.message !== "无数据";
        const rows = ok ? (((res || {}).data || {}).obj || {}).resultData || [] : [];
        if (!rows.length) {
          this.loading = true;
          return;
        }
        this.list = this.list.concat(rows);
      } catch (e) {
        // 请求失败不改 loading，允许用户继续滚动重试
      } finally {
        this.isFetching = false;
      }
    },
    /** 事件：搜索输入变化，重置分页并查询 */
    handleQuery(){
      this.resetAndFetch();
    },
    /** 事件：切换类型，重置分页并查询 */
    handleTab(num) {
      if (this.current === num) return;
      this.current = num;
      this.resetAndFetch();
    },
    resetAndFetch() {
      this.loading = false;
      this.list = [];
      this.pagemun = 1;
      this.getList();
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  /deep/ .van-search__content{
    background-color: #E4E4E4;
  }
  .ss_icon{
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  .type_cl{
    display: flex;
    flex-flow: row nowrap;
    background: rgb(255, 255, 255);
    padding: 10px;
    border-top: 1px solid rgb(218, 218, 218);
    border-bottom: 1px solid rgb(218, 218, 218);
    letter-spacing: 1px;
    font-size: 14px;
    align-items: center;
    .title{
      font-weight: bold;
    }
    .option{
      text-align: center;
      margin-left: 20px;
      padding: 2px 10px;
      border: 1px solid rgb(180, 180, 180);
      border-radius: 20px;
      color: rgb(180, 180, 180);
    }
    .gg{
      border-color: rgba(81, 203, 255, 0.6);
      background: rgba(81, 203, 255, 0.4);
      color: #51cbff;
    }
  }
  .list_cl{
    background: #fff;
    font-size: 14px;
    display: flex;
    flex-flow: column nowrap;
    >li{
      display: flex;
      flex-flow: row nowrap;
      padding: 10px;
      border-bottom: 1px solid rgb(218, 218, 218);
      align-items: center;
      >span{
        // flex: 2;
        text-align: center;
        word-wrap:break-word;
      }
      >span:nth-child(1){
        flex: 1;
      }
      >span:nth-child(2),span:nth-child(3){
        width: 80px;
      }
      >span:nth-child(4){
        width: 40px;
      }
      >span:nth-child(5){
        width: 80px;
      }
    }
    >li:nth-child(1){
      font-weight: bold;
    }
  }
  .load_cal{
    text-align: center;
    padding: 20px 0px;
    color: #999;
    font-size: 14px;
    letter-spacing: 1px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/PriceInquiry.vue